export const STOREFRONT_ACCOUNT_KINDS = ["school", "library", "other"];
export function isStorefrontAccountKind(value) {
    return (typeof value === "string" &&
        STOREFRONT_ACCOUNT_KINDS.includes(value));
}
export const STOREFRONT_MEMBER_ROLES = ["admin", "member"];
export function isStorefrontMemberRole(value) {
    return (typeof value === "string" &&
        STOREFRONT_MEMBER_ROLES.includes(value));
}
export function storefrontSubjects(member) {
    const subjects = [];
    if (member.accountId) {
        subjects.push({ kind: "organisation", id: member.accountId });
    }
    subjects.push({ kind: "person", id: member.id });
    return subjects;
}
export function normaliseCustomerEmail(value) {
    return typeof value === "string" ? value.trim().toLowerCase() : "";
}
export function isInviteRedeemable(member, now = new Date()) {
    if (!member.enabled)
        return false;
    if (member.acceptedAt)
        return false;
    if (!member.expiresAt)
        return true;
    return new Date(member.expiresAt).getTime() > now.getTime();
}
